//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import store from "store2";import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class ApiClientBase {

    public transformOptions(options: any) {
        const token = store("token");
        const old_headers = options.headers;
        const new_headers: { [key: string]: string } = {};
        Object.keys(old_headers).forEach((k: any) => {
            new_headers[k] = old_headers[k];
        });
        if (token && token !== '') {
            new_headers['Authorization'] = 'Bearer ' + token;
        }

        options.headers = new_headers;
        options.reportProgress = true;

        return Promise.resolve(options);
    }
}

export class AccountClient extends ApiClientBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5002";

    }

    createAccount(request: CreateAccountRequest , cancelToken?: CancelToken | undefined): Promise<CreateAccountResponse> {
        let url_ = this.baseUrl + "/createAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAccount(_response);
        });
    }

    protected processCreateAccount(response: AxiosResponse): Promise<CreateAccountResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateAccountResponse.fromJS(resultData200);
            return Promise.resolve<CreateAccountResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateAccountResponse>(null as any);
    }
}

export class AdvertisementClient extends ApiClientBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5002";

    }

    list(  cancelToken?: CancelToken | undefined): Promise<AdvertisementDTO[]> {
        let url_ = this.baseUrl + "/api/Advertisement/List";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<AdvertisementDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdvertisementDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AdvertisementDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdvertisementDTO[]>(null as any);
    }

    photographer(id: number , cancelToken?: CancelToken | undefined): Promise<AdvertisementDTO[]> {
        let url_ = this.baseUrl + "/api/Advertisement/Photographer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPhotographer(_response);
        });
    }

    protected processPhotographer(response: AxiosResponse): Promise<AdvertisementDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdvertisementDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AdvertisementDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdvertisementDTO[]>(null as any);
    }

    details(id: number , cancelToken?: CancelToken | undefined): Promise<AdvertisementDTO> {
        let url_ = this.baseUrl + "/api/Advertisement/Details/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetails(_response);
        });
    }

    protected processDetails(response: AxiosResponse): Promise<AdvertisementDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AdvertisementDTO.fromJS(resultData200);
            return Promise.resolve<AdvertisementDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdvertisementDTO>(null as any);
    }

    create(data: AdvertisementDTO , cancelToken?: CancelToken | undefined): Promise<AdvertisementDTO> {
        let url_ = this.baseUrl + "/api/Advertisement/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<AdvertisementDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AdvertisementDTO.fromJS(resultData200);
            return Promise.resolve<AdvertisementDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdvertisementDTO>(null as any);
    }

    update(data: AdvertisementDTO , cancelToken?: CancelToken | undefined): Promise<AdvertisementDTO> {
        let url_ = this.baseUrl + "/api/Advertisement/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<AdvertisementDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AdvertisementDTO.fromJS(resultData200);
            return Promise.resolve<AdvertisementDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdvertisementDTO>(null as any);
    }

    delete(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Advertisement/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    reorder(ids: number[] | null | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Advertisement/Reorder?";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReorder(_response);
        });
    }

    protected processReorder(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class FileClient extends ApiClientBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5002";

    }

    upload(file: FileParameter | null | undefined, fileType: MultimediaTypesEnum | undefined , cancelToken?: CancelToken | undefined): Promise<FileDTO> {
        let url_ = this.baseUrl + "/api/File/Upload?";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: AxiosResponse): Promise<FileDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDTO.fromJS(resultData200);
            return Promise.resolve<FileDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDTO>(null as any);
    }
}

export class PhotographerClient extends ApiClientBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5002";

    }

    settings(photographerId: number , cancelToken?: CancelToken | undefined): Promise<UserSettingsDTO> {
        let url_ = this.baseUrl + "/api/Photographer/Settings/{photographerId}";
        if (photographerId === undefined || photographerId === null)
            throw new Error("The parameter 'photographerId' must be defined.");
        url_ = url_.replace("{photographerId}", encodeURIComponent("" + photographerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSettings(_response);
        });
    }

    protected processSettings(response: AxiosResponse): Promise<UserSettingsDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserSettingsDTO.fromJS(resultData200);
            return Promise.resolve<UserSettingsDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserSettingsDTO>(null as any);
    }

    settingsByEvent(eventId: number , cancelToken?: CancelToken | undefined): Promise<UserSettingsDTO> {
        let url_ = this.baseUrl + "/api/Photographer/Settings/Event/{eventId}";
        if (eventId === undefined || eventId === null)
            throw new Error("The parameter 'eventId' must be defined.");
        url_ = url_.replace("{eventId}", encodeURIComponent("" + eventId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSettingsByEvent(_response);
        });
    }

    protected processSettingsByEvent(response: AxiosResponse): Promise<UserSettingsDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserSettingsDTO.fromJS(resultData200);
            return Promise.resolve<UserSettingsDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserSettingsDTO>(null as any);
    }

    edit(userId: number | undefined, helpVideoMobile: string | null | undefined, helpVideoDesktop: string | null | undefined, bannerFile: FileParameter | null | undefined , cancelToken?: CancelToken | undefined): Promise<UserSettingsDTO> {
        let url_ = this.baseUrl + "/api/Photographer/Edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (userId === null || userId === undefined)
            throw new Error("The parameter 'userId' cannot be null.");
        else
            content_.append("UserId", userId.toString());
        if (helpVideoMobile !== null && helpVideoMobile !== undefined)
            content_.append("HelpVideoMobile", helpVideoMobile.toString());
        if (helpVideoDesktop !== null && helpVideoDesktop !== undefined)
            content_.append("HelpVideoDesktop", helpVideoDesktop.toString());
        if (bannerFile !== null && bannerFile !== undefined)
            content_.append("BannerFile", bannerFile.data, bannerFile.fileName ? bannerFile.fileName : "BannerFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEdit(_response);
        });
    }

    protected processEdit(response: AxiosResponse): Promise<UserSettingsDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserSettingsDTO.fromJS(resultData200);
            return Promise.resolve<UserSettingsDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserSettingsDTO>(null as any);
    }
}

export class TemplateClient extends ApiClientBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5002";

    }

    create(  cancelToken?: CancelToken | undefined): Promise<Template> {
        let url_ = this.baseUrl + "/api/Template/create";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<Template> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Template.fromJS(resultData200);
            return Promise.resolve<Template>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Template>(null as any);
    }

    import(  cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Template/import";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class AuthClient extends ApiClientBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5002";

    }

    authenticate(request: AuthenticateRequest , cancelToken?: CancelToken | undefined): Promise<AuthenticateResponse> {
        let url_ = this.baseUrl + "/authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthenticate(_response);
        });
    }

    protected processAuthenticate(response: AxiosResponse): Promise<AuthenticateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthenticateResponse.fromJS(resultData200);
            return Promise.resolve<AuthenticateResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticateResponse>(null as any);
    }
}

export class EventClient extends ApiClientBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5002";

    }

    xmEventNames(id: number , cancelToken?: CancelToken | undefined): Promise<EventFileInfoDTO[]> {
        let url_ = this.baseUrl + "/api/xmlEventNames/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processXmEventNames(_response);
        });
    }

    protected processXmEventNames(response: AxiosResponse): Promise<EventFileInfoDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EventFileInfoDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EventFileInfoDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EventFileInfoDTO[]>(null as any);
    }
}

export class HomeClient extends ApiClientBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5002";

    }

    index(  cancelToken?: CancelToken | undefined): Promise<Date> {
        let url_ = this.baseUrl + "/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIndex(_response);
        });
    }

    protected processIndex(response: AxiosResponse): Promise<Date> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 ? new Date(resultData200.toString()) : <any>null;

            return Promise.resolve<Date>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Date>(null as any);
    }
}

export class ProductsClient extends ApiClientBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5002";

    }

    photographer(photographerId: number , cancelToken?: CancelToken | undefined): Promise<ProductDTO[]> {
        let url_ = this.baseUrl + "/api/Products/photographer/{photographerId}";
        if (photographerId === undefined || photographerId === null)
            throw new Error("The parameter 'photographerId' must be defined.");
        url_ = url_.replace("{photographerId}", encodeURIComponent("" + photographerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPhotographer(_response);
        });
    }

    protected processPhotographer(response: AxiosResponse): Promise<ProductDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProductDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductDTO[]>(null as any);
    }

    add3DProduct(name: string | null | undefined, description: string | null | undefined, imageFile: FileParameter | null | undefined, layerImageFile: FileParameter | null | undefined, sizesRequest: string[] | null | undefined, sizes: ProductsTemplateDTO[] | null | undefined, productPricesRequest: string[] | null | undefined, productPrices: ProductPriceDTO[] | null | undefined, categoriesIds: number[] | null | undefined, attributesIds: number[] | null | undefined, model3D: number | undefined , cancelToken?: CancelToken | undefined): Promise<ProductDTO> {
        let url_ = this.baseUrl + "/api/Products/add/3dproduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name !== null && name !== undefined)
            content_.append("name", name.toString());
        if (description !== null && description !== undefined)
            content_.append("description", description.toString());
        if (imageFile !== null && imageFile !== undefined)
            content_.append("imageFile", imageFile.data, imageFile.fileName ? imageFile.fileName : "imageFile");
        if (layerImageFile !== null && layerImageFile !== undefined)
            content_.append("layerImageFile", layerImageFile.data, layerImageFile.fileName ? layerImageFile.fileName : "layerImageFile");
        if (sizesRequest !== null && sizesRequest !== undefined)
            sizesRequest.forEach(item_ => content_.append("sizesRequest", item_.toString()));
        if (sizes !== null && sizes !== undefined)
            sizes.forEach(item_ => content_.append("sizes", item_.toString()));
        if (productPricesRequest !== null && productPricesRequest !== undefined)
            productPricesRequest.forEach(item_ => content_.append("productPricesRequest", item_.toString()));
        if (productPrices !== null && productPrices !== undefined)
            productPrices.forEach(item_ => content_.append("productPrices", item_.toString()));
        if (categoriesIds !== null && categoriesIds !== undefined)
            categoriesIds.forEach(item_ => content_.append("categoriesIds", item_.toString()));
        if (attributesIds !== null && attributesIds !== undefined)
            attributesIds.forEach(item_ => content_.append("attributesIds", item_.toString()));
        if (model3D === null || model3D === undefined)
            throw new Error("The parameter 'model3D' cannot be null.");
        else
            content_.append("model3D", model3D.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdd3DProduct(_response);
        });
    }

    protected processAdd3DProduct(response: AxiosResponse): Promise<ProductDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductDTO.fromJS(resultData200);
            return Promise.resolve<ProductDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductDTO>(null as any);
    }

    addAlbumProduct(name: string | null | undefined, description: string | null | undefined, imageFile: FileParameter | null | undefined, layerImageFile: FileParameter | null | undefined, sizesRequest: string[] | null | undefined, sizes: ProductsTemplateDTO[] | null | undefined, productPricesRequest: string[] | null | undefined, productPrices: ProductPriceDTO[] | null | undefined, categoriesIds: number[] | null | undefined, attributesIds: number[] | null | undefined, albumModel: number | undefined , cancelToken?: CancelToken | undefined): Promise<ProductDTO> {
        let url_ = this.baseUrl + "/api/products/add/album";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name !== null && name !== undefined)
            content_.append("name", name.toString());
        if (description !== null && description !== undefined)
            content_.append("description", description.toString());
        if (imageFile !== null && imageFile !== undefined)
            content_.append("imageFile", imageFile.data, imageFile.fileName ? imageFile.fileName : "imageFile");
        if (layerImageFile !== null && layerImageFile !== undefined && Array.isArray(layerImageFile) ){
            layerImageFile.forEach(lif=>{
              content_.append("layerImageFiles", lif.data, lif.fileName ? lif.fileName : "layerImageFile");
            })
            content_.append("LayerImageFileNames", "[" + layerImageFile.map(lif=>lif.fileName ? lif.fileName : "layerImageFile").join(", ") +"]" );
        }
        if (sizesRequest !== null && sizesRequest !== undefined)
            sizesRequest.flat().forEach(item_ => content_.append("sizesRequest", item_.toString()));
        if (productPricesRequest !== null && productPricesRequest !== undefined)
            productPricesRequest.forEach(item_ => content_.append("productPricesRequest", item_.toString()));
        if (productPrices !== null && productPrices !== undefined)
            productPrices.forEach(item_ => content_.append("productPrices", item_.toString()));
        if (categoriesIds !== null && categoriesIds !== undefined)
            categoriesIds.forEach(item_ => content_.append("categoriesIds", item_.toString()));
        if (attributesIds !== null && attributesIds !== undefined)
            attributesIds.forEach(item_ => content_.append("attributesIds", item_.toString()));
        if (albumModel === null || albumModel === undefined)
            throw new Error("The parameter 'albumId' cannot be null.");
        else
            content_.append("albumModel", albumModel.toString());
        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddAlbumProduct(_response);
        });
    }

    protected processAddAlbumProduct(response: AxiosResponse): Promise<ProductDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductDTO.fromJS(resultData200);
            return Promise.resolve<ProductDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductDTO>(null as any);
    }

    //FIXME: change link to let url_ = this.baseUrl + "/api/products/add/calendar";
    addCalendarProduct(name: string | null | undefined, description: string | null | undefined, imageFile: FileParameter | null | undefined, layerImageFile: FileParameter | null | undefined, sizesRequest: string[] | null | undefined, sizes: ProductsTemplateDTO[] | null | undefined, productPricesRequest: string[] | null | undefined, productPrices: ProductPriceDTO[] | null | undefined, categoriesIds: number[] | null | undefined, attributesIds: number[] | null | undefined, calendarModel: number | undefined , cancelToken?: CancelToken | undefined): Promise<ProductDTO> {
        let url_ = this.baseUrl + "/api/products/add/calendar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name !== null && name !== undefined)
            content_.append("name", name.toString());
        if (description !== null && description !== undefined)
            content_.append("description", description.toString());
        if (imageFile !== null && imageFile !== undefined)
            content_.append("imageFile", imageFile.data, imageFile.fileName ? imageFile.fileName : "imageFile");
        if (layerImageFile !== null && layerImageFile !== undefined && Array.isArray(layerImageFile) ){
            layerImageFile.forEach(lif=>{
              content_.append("layerImageFiles", lif.data, lif.fileName ? lif.fileName : "layerImageFile");
            })
            content_.append("LayerImageFileNames", "[" + layerImageFile.map(lif=>lif.fileName ? lif.fileName : "layerImageFile").join(", ") +"]" );
        }
        if (sizesRequest !== null && sizesRequest !== undefined)
            sizesRequest.flat().forEach(item_ => content_.append("sizesRequest", item_.toString()));
        if (productPricesRequest !== null && productPricesRequest !== undefined)
            productPricesRequest.forEach(item_ => content_.append("productPricesRequest", item_.toString()));
        if (productPrices !== null && productPrices !== undefined)
            productPrices.forEach(item_ => content_.append("productPrices", item_.toString()));
        if (categoriesIds !== null && categoriesIds !== undefined)
            categoriesIds.forEach(item_ => content_.append("categoriesIds", item_.toString()));
        if (attributesIds !== null && attributesIds !== undefined)
            attributesIds.forEach(item_ => content_.append("attributesIds", item_.toString()));
        if (calendarModel === null || calendarModel === undefined)
            throw new Error("The parameter 'calendarId' cannot be null.");
        else
            content_.append("calendarModel", calendarModel.toString());
        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddCalendarProduct(_response);
        });
    }

    protected processAddCalendarProduct(response: AxiosResponse): Promise<ProductDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductDTO.fromJS(resultData200);
            return Promise.resolve<ProductDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductDTO>(null as any);
    }

    get3DModels(  cancelToken?: CancelToken | undefined): Promise<Models3D[]> {
        let url_ = this.baseUrl + "/api/Products/get/3dModels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet3DModels(_response);
        });
    }

    protected processGet3DModels(response: AxiosResponse): Promise<Models3D[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Models3D.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Models3D[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Models3D[]>(null as any);
    }

    getAlbumModels(  cancelToken?: CancelToken | undefined): Promise<Album[]> {
        let url_ = this.baseUrl + "/api/products/albums";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAlbumModels(_response);
        });
    }

    protected processGetAlbumModels(response: AxiosResponse): Promise<Album[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Album.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Album[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Album[]>(null as any);
    }

    //FIXME: change link to  let url_ = this.baseUrl + "/api/products/calendars";
getCalendarModels(  cancelToken?: CancelToken | undefined): Promise<Calendar[]> {
    let url_ = this.baseUrl + "/api/products/calendars";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        },
        cancelToken
    };

    return this.transformOptions(options_).then(transformedOptions_ => {
        return this.instance.request(transformedOptions_);
    }).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return this.processGetCalendarModels(_response);
    });
}

protected processGetCalendarModels(response: AxiosResponse): Promise<Calendar[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(Calendar.fromJS(item));
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<Calendar[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Calendar[]>(null as any);
}
}



export class ShoppingCartClient extends ApiClientBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5002";

    }

    addToFavourites(folderId: number | undefined, photoId: number | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ShoppingCart/addToFavourites?";
        if (folderId === null)
            throw new Error("The parameter 'folderId' cannot be null.");
        else if (folderId !== undefined)
            url_ += "folderId=" + encodeURIComponent("" + folderId) + "&";
        if (photoId === null)
            throw new Error("The parameter 'photoId' cannot be null.");
        else if (photoId !== undefined)
            url_ += "photoId=" + encodeURIComponent("" + photoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddToFavourites(_response);
        });
    }

    protected processAddToFavourites(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    addToFavouritesList(folderId: number | undefined, photoList: number[] , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ShoppingCart/addToFavourites/list?";
        if (folderId === null)
            throw new Error("The parameter 'folderId' cannot be null.");
        else if (folderId !== undefined)
            url_ += "folderId=" + encodeURIComponent("" + folderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(photoList);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddToFavouritesList(_response);
        });
    }

    protected processAddToFavouritesList(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    removeFromFavourites(folderId: number | undefined, photoId: number | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ShoppingCart/removeFromFavourites?";
        if (folderId === null)
            throw new Error("The parameter 'folderId' cannot be null.");
        else if (folderId !== undefined)
            url_ += "folderId=" + encodeURIComponent("" + folderId) + "&";
        if (photoId === null)
            throw new Error("The parameter 'photoId' cannot be null.");
        else if (photoId !== undefined)
            url_ += "photoId=" + encodeURIComponent("" + photoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveFromFavourites(_response);
        });
    }

    protected processRemoveFromFavourites(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    getFavourites(folderId: number | undefined , cancelToken?: CancelToken | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/api/ShoppingCart/getFavourites?";
        if (folderId === null)
            throw new Error("The parameter 'folderId' cannot be null.");
        else if (folderId !== undefined)
            url_ += "folderId=" + encodeURIComponent("" + folderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFavourites(_response);
        });
    }

    protected processGetFavourites(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<number[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number[]>(null as any);
    }

    setShoppingCart(folderId: number | undefined, item: ShoppingCartItem , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ShoppingCart/setShoppingCart?";
        if (folderId === null)
            throw new Error("The parameter 'folderId' cannot be null.");
        else if (folderId !== undefined)
            url_ += "folderId=" + encodeURIComponent("" + folderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetShoppingCart(_response);
        });
    }

    protected processSetShoppingCart(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    setShoppingCartList(folderId: number | undefined, item: ShoppingCartItem[] , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ShoppingCart/setShoppingCart/list?";
        if (folderId === null)
            throw new Error("The parameter 'folderId' cannot be null.");
        else if (folderId !== undefined)
            url_ += "folderId=" + encodeURIComponent("" + folderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetShoppingCartList(_response);
        });
    }

    protected processSetShoppingCartList(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    clearShoppingCart(  cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ShoppingCart/clearShoppingCart";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClearShoppingCart(_response);
        });
    }

    protected processClearShoppingCart(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    getShoppingCart(  cancelToken?: CancelToken | undefined): Promise<{ [key: string]: ShoppingCartItem[]; }> {
        let url_ = this.baseUrl + "/api/ShoppingCart/getShoppingCart";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShoppingCart(_response);
        });
    }

    protected processGetShoppingCart(response: AxiosResponse): Promise<{ [key: string]: ShoppingCartItem[]; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] ? resultData200[key].map((i: any) => ShoppingCartItem.fromJS(i)) : [];
                }
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<{ [key: string]: ShoppingCartItem[]; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: ShoppingCartItem[]; }>(null as any);
    }
}

export class Response implements IResponse {
    error!: string;

    constructor(data?: IResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"] !== undefined ? _data["error"] : <any>null;
        }
    }

    static fromJS(data: any): Response {
        data = typeof data === 'object' ? data : {};
        let result = new Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error !== undefined ? this.error : <any>null;
        return data;
    }

    clone(): Response {
        const json = this.toJSON();
        let result = new Response();
        result.init(json);
        return result;
    }
}

export interface IResponse {
    error: string;
}

export class CreateAccountResponse extends Response implements ICreateAccountResponse {
    success!: boolean;

    constructor(data?: ICreateAccountResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.success = _data["success"] !== undefined ? _data["success"] : <any>null;
        }
    }

    static fromJS(data: any): CreateAccountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAccountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success !== undefined ? this.success : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): CreateAccountResponse {
        const json = this.toJSON();
        let result = new CreateAccountResponse();
        result.init(json);
        return result;
    }
}

export interface ICreateAccountResponse extends IResponse {
    success: boolean;
}

export class CreateAccountRequest implements ICreateAccountRequest {
    username!: string;
    email!: string;
    password!: string;

    constructor(data?: ICreateAccountRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"] !== undefined ? _data["username"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
        }
    }

    static fromJS(data: any): CreateAccountRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAccountRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username !== undefined ? this.username : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        return data;
    }

    clone(): CreateAccountRequest {
        const json = this.toJSON();
        let result = new CreateAccountRequest();
        result.init(json);
        return result;
    }
}

export interface ICreateAccountRequest {
    username: string;
    email: string;
    password: string;
}

export class AdvertisementDTO implements IAdvertisementDTO {
    id!: number;
    photographerId!: number;
    productId?: number | null;
    externalUrl?: string | null;
    buttonText?: string | null;
    fileGuid?: string | null;
    fileName?: string | null;
    imageUrl?: string | null;
    mobileFileGuid?: string | null;
    mobileFileName?: string | null;
    mobileImageUrl?: string | null;
    isDeleted?: boolean | null;
    isHidden?: boolean | null;
    createDate?: Date | null;
    modificationDate?: Date | null;
    position?: number | null;

    constructor(data?: IAdvertisementDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.photographerId = _data["photographerId"] !== undefined ? _data["photographerId"] : <any>null;
            this.productId = _data["productId"] !== undefined ? _data["productId"] : <any>null;
            this.externalUrl = _data["externalUrl"] !== undefined ? _data["externalUrl"] : <any>null;
            this.buttonText = _data["buttonText"] !== undefined ? _data["buttonText"] : <any>null;
            this.fileGuid = _data["fileGuid"] !== undefined ? _data["fileGuid"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : <any>null;
            this.mobileFileGuid = _data["mobileFileGuid"] !== undefined ? _data["mobileFileGuid"] : <any>null;
            this.mobileFileName = _data["mobileFileName"] !== undefined ? _data["mobileFileName"] : <any>null;
            this.mobileImageUrl = _data["mobileImageUrl"] !== undefined ? _data["mobileImageUrl"] : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
            this.isHidden = _data["isHidden"] !== undefined ? _data["isHidden"] : <any>null;
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>null;
            this.modificationDate = _data["modificationDate"] ? new Date(_data["modificationDate"].toString()) : <any>null;
            this.position = _data["position"] !== undefined ? _data["position"] : <any>null;
        }
    }

    static fromJS(data: any): AdvertisementDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AdvertisementDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["photographerId"] = this.photographerId !== undefined ? this.photographerId : <any>null;
        data["productId"] = this.productId !== undefined ? this.productId : <any>null;
        data["externalUrl"] = this.externalUrl !== undefined ? this.externalUrl : <any>null;
        data["buttonText"] = this.buttonText !== undefined ? this.buttonText : <any>null;
        data["fileGuid"] = this.fileGuid !== undefined ? this.fileGuid : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : <any>null;
        data["mobileFileGuid"] = this.mobileFileGuid !== undefined ? this.mobileFileGuid : <any>null;
        data["mobileFileName"] = this.mobileFileName !== undefined ? this.mobileFileName : <any>null;
        data["mobileImageUrl"] = this.mobileImageUrl !== undefined ? this.mobileImageUrl : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        data["isHidden"] = this.isHidden !== undefined ? this.isHidden : <any>null;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>null;
        data["modificationDate"] = this.modificationDate ? this.modificationDate.toISOString() : <any>null;
        data["position"] = this.position !== undefined ? this.position : <any>null;
        return data;
    }

    clone(): AdvertisementDTO {
        const json = this.toJSON();
        let result = new AdvertisementDTO();
        result.init(json);
        return result;
    }
}

export interface IAdvertisementDTO {
    id: number;
    photographerId: number;
    productId?: number | null;
    externalUrl?: string | null;
    buttonText?: string | null;
    fileGuid?: string | null;
    fileName?: string | null;
    imageUrl?: string | null;
    mobileFileGuid?: string | null;
    mobileFileName?: string | null;
    mobileImageUrl?: string | null;
    isDeleted?: boolean | null;
    isHidden?: boolean | null;
    createDate?: Date | null;
    modificationDate?: Date | null;
    position?: number | null;
}

export class FileDTO implements IFileDTO {
    url!: string;
    name!: string;
    guid!: string;

    constructor(data?: IFileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.guid = _data["guid"] !== undefined ? _data["guid"] : <any>null;
        }
    }

    static fromJS(data: any): FileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["guid"] = this.guid !== undefined ? this.guid : <any>null;
        return data;
    }

    clone(): FileDTO {
        const json = this.toJSON();
        let result = new FileDTO();
        result.init(json);
        return result;
    }
}

export interface IFileDTO {
    url: string;
    name: string;
    guid: string;
}

export enum MultimediaTypesEnum {
    Background = 0,
    Logo = 1,
    Product = 2,
    Promotion = 3,
    AppBranding = 4,
    CategoryLogo = 5,
    AttributeLogo = 6,
    AdvertisementSlider = 7,
}

export class UserSettingsDTO implements IUserSettingsDTO {
    userId!: number;
    helpVideoMobile?: string | null;
    helpVideoDesktop?: string | null;
    bannerPhotoUrl?: string | null;

    constructor(data?: IUserSettingsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.helpVideoMobile = _data["helpVideoMobile"] !== undefined ? _data["helpVideoMobile"] : <any>null;
            this.helpVideoDesktop = _data["helpVideoDesktop"] !== undefined ? _data["helpVideoDesktop"] : <any>null;
            this.bannerPhotoUrl = _data["bannerPhotoUrl"] !== undefined ? _data["bannerPhotoUrl"] : <any>null;
        }
    }

    static fromJS(data: any): UserSettingsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserSettingsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["helpVideoMobile"] = this.helpVideoMobile !== undefined ? this.helpVideoMobile : <any>null;
        data["helpVideoDesktop"] = this.helpVideoDesktop !== undefined ? this.helpVideoDesktop : <any>null;
        data["bannerPhotoUrl"] = this.bannerPhotoUrl !== undefined ? this.bannerPhotoUrl : <any>null;
        return data;
    }

    clone(): UserSettingsDTO {
        const json = this.toJSON();
        let result = new UserSettingsDTO();
        result.init(json);
        return result;
    }
}

export interface IUserSettingsDTO {
    userId: number;
    helpVideoMobile?: string | null;
    helpVideoDesktop?: string | null;
    bannerPhotoUrl?: string | null;
}

export class Template implements ITemplate {
    categories!: TemplateCategory[];
    attributesGroups!: TemplateAttributeGroup[];
    products!: TemplateProduct[];

    constructor(data?: ITemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.categories = [];
            this.attributesGroups = [];
            this.products = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(TemplateCategory.fromJS(item));
            }
            else {
                this.categories = <any>null;
            }
            if (Array.isArray(_data["attributesGroups"])) {
                this.attributesGroups = [] as any;
                for (let item of _data["attributesGroups"])
                    this.attributesGroups!.push(TemplateAttributeGroup.fromJS(item));
            }
            else {
                this.attributesGroups = <any>null;
            }
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(TemplateProduct.fromJS(item));
            }
            else {
                this.products = <any>null;
            }
        }
    }

    static fromJS(data: any): Template {
        data = typeof data === 'object' ? data : {};
        let result = new Template();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        if (Array.isArray(this.attributesGroups)) {
            data["attributesGroups"] = [];
            for (let item of this.attributesGroups)
                data["attributesGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        return data;
    }

    clone(): Template {
        const json = this.toJSON();
        let result = new Template();
        result.init(json);
        return result;
    }
}

export interface ITemplate {
    categories: TemplateCategory[];
    attributesGroups: TemplateAttributeGroup[];
    products: TemplateProduct[];
}

export class TemplateCategory implements ITemplateCategory {
    id!: number;
    name!: string;
    externalKey?: string | null;
    photographerId?: number | null;
    description?: string | null;
    fileGuid?: string | null;
    fileName?: string | null;
    position?: number | null;
    isHidden?: boolean | null;
    productsPositionDefinition?: string | null;
    moduleType?: number | null;

    constructor(data?: ITemplateCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.externalKey = _data["externalKey"] !== undefined ? _data["externalKey"] : <any>null;
            this.photographerId = _data["photographerId"] !== undefined ? _data["photographerId"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.fileGuid = _data["fileGuid"] !== undefined ? _data["fileGuid"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.position = _data["position"] !== undefined ? _data["position"] : <any>null;
            this.isHidden = _data["isHidden"] !== undefined ? _data["isHidden"] : <any>null;
            this.productsPositionDefinition = _data["productsPositionDefinition"] !== undefined ? _data["productsPositionDefinition"] : <any>null;
            this.moduleType = _data["moduleType"] !== undefined ? _data["moduleType"] : <any>null;
        }
    }

    static fromJS(data: any): TemplateCategory {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["externalKey"] = this.externalKey !== undefined ? this.externalKey : <any>null;
        data["photographerId"] = this.photographerId !== undefined ? this.photographerId : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["fileGuid"] = this.fileGuid !== undefined ? this.fileGuid : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["position"] = this.position !== undefined ? this.position : <any>null;
        data["isHidden"] = this.isHidden !== undefined ? this.isHidden : <any>null;
        data["productsPositionDefinition"] = this.productsPositionDefinition !== undefined ? this.productsPositionDefinition : <any>null;
        data["moduleType"] = this.moduleType !== undefined ? this.moduleType : <any>null;
        return data;
    }

    clone(): TemplateCategory {
        const json = this.toJSON();
        let result = new TemplateCategory();
        result.init(json);
        return result;
    }
}

export interface ITemplateCategory {
    id: number;
    name: string;
    externalKey?: string | null;
    photographerId?: number | null;
    description?: string | null;
    fileGuid?: string | null;
    fileName?: string | null;
    position?: number | null;
    isHidden?: boolean | null;
    productsPositionDefinition?: string | null;
    moduleType?: number | null;
}

export class TemplateAttributeGroup implements ITemplateAttributeGroup {
    id!: number;
    name!: string;
    externalKey?: string | null;
    isActive?: boolean | null;
    position?: number | null;
    moduleType?: number | null;
    photographerId?: number | null;
    attributes!: TemplateAttribute[];

    constructor(data?: ITemplateAttributeGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.attributes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.externalKey = _data["externalKey"] !== undefined ? _data["externalKey"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.position = _data["position"] !== undefined ? _data["position"] : <any>null;
            this.moduleType = _data["moduleType"] !== undefined ? _data["moduleType"] : <any>null;
            this.photographerId = _data["photographerId"] !== undefined ? _data["photographerId"] : <any>null;
            if (Array.isArray(_data["attributes"])) {
                this.attributes = [] as any;
                for (let item of _data["attributes"])
                    this.attributes!.push(TemplateAttribute.fromJS(item));
            }
            else {
                this.attributes = <any>null;
            }
        }
    }

    static fromJS(data: any): TemplateAttributeGroup {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateAttributeGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["externalKey"] = this.externalKey !== undefined ? this.externalKey : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["position"] = this.position !== undefined ? this.position : <any>null;
        data["moduleType"] = this.moduleType !== undefined ? this.moduleType : <any>null;
        data["photographerId"] = this.photographerId !== undefined ? this.photographerId : <any>null;
        if (Array.isArray(this.attributes)) {
            data["attributes"] = [];
            for (let item of this.attributes)
                data["attributes"].push(item.toJSON());
        }
        return data;
    }

    clone(): TemplateAttributeGroup {
        const json = this.toJSON();
        let result = new TemplateAttributeGroup();
        result.init(json);
        return result;
    }
}

export interface ITemplateAttributeGroup {
    id: number;
    name: string;
    externalKey?: string | null;
    isActive?: boolean | null;
    position?: number | null;
    moduleType?: number | null;
    photographerId?: number | null;
    attributes: TemplateAttribute[];
}

export class TemplateAttribute implements ITemplateAttribute {
    id!: number;
    name!: string;
    photographerId?: number | null;
    description?: string | null;
    fileGuid?: string | null;
    fileName?: string | null;
    position?: number | null;
    priceCorrectionCurrent?: number | null;
    priceCorrectionPercent?: number | null;
    moduleType?: number | null;

    constructor(data?: ITemplateAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.photographerId = _data["photographerId"] !== undefined ? _data["photographerId"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.fileGuid = _data["fileGuid"] !== undefined ? _data["fileGuid"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.position = _data["position"] !== undefined ? _data["position"] : <any>null;
            this.priceCorrectionCurrent = _data["priceCorrectionCurrent"] !== undefined ? _data["priceCorrectionCurrent"] : <any>null;
            this.priceCorrectionPercent = _data["priceCorrectionPercent"] !== undefined ? _data["priceCorrectionPercent"] : <any>null;
            this.moduleType = _data["moduleType"] !== undefined ? _data["moduleType"] : <any>null;
        }
    }

    static fromJS(data: any): TemplateAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateAttribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["photographerId"] = this.photographerId !== undefined ? this.photographerId : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["fileGuid"] = this.fileGuid !== undefined ? this.fileGuid : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["position"] = this.position !== undefined ? this.position : <any>null;
        data["priceCorrectionCurrent"] = this.priceCorrectionCurrent !== undefined ? this.priceCorrectionCurrent : <any>null;
        data["priceCorrectionPercent"] = this.priceCorrectionPercent !== undefined ? this.priceCorrectionPercent : <any>null;
        data["moduleType"] = this.moduleType !== undefined ? this.moduleType : <any>null;
        return data;
    }

    clone(): TemplateAttribute {
        const json = this.toJSON();
        let result = new TemplateAttribute();
        result.init(json);
        return result;
    }
}

export interface ITemplateAttribute {
    id: number;
    name: string;
    photographerId?: number | null;
    description?: string | null;
    fileGuid?: string | null;
    fileName?: string | null;
    position?: number | null;
    priceCorrectionCurrent?: number | null;
    priceCorrectionPercent?: number | null;
    moduleType?: number | null;
}

export class TemplateProduct implements ITemplateProduct {
    id!: number;
    name?: string | null;
    description?: string | null;
    price?: number | null;
    fileGuid?: string | null;
    fileName?: string | null;
    photographerId?: number | null;
    size?: number | null;
    quantityRangeMin?: number | null;
    quantityRangeMax?: number | null;
    isAutoGenerated?: boolean | null;
    mainProductId?: number | null;
    autoGeneratedDefinition?: string | null;
    isHidden?: boolean | null;
    moduleType?: number | null;
    productType?: number | null;
    productAttributes!: number[];
    productCategories!: number[];
    productImages!: TemplateProductImage[];
    productPrices!: TemplateProductPrices[];

    constructor(data?: ITemplateProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.productAttributes = [];
            this.productCategories = [];
            this.productImages = [];
            this.productPrices = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.fileGuid = _data["fileGuid"] !== undefined ? _data["fileGuid"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.photographerId = _data["photographerId"] !== undefined ? _data["photographerId"] : <any>null;
            this.size = _data["size"] !== undefined ? _data["size"] : <any>null;
            this.quantityRangeMin = _data["quantityRangeMin"] !== undefined ? _data["quantityRangeMin"] : <any>null;
            this.quantityRangeMax = _data["quantityRangeMax"] !== undefined ? _data["quantityRangeMax"] : <any>null;
            this.isAutoGenerated = _data["isAutoGenerated"] !== undefined ? _data["isAutoGenerated"] : <any>null;
            this.mainProductId = _data["mainProductId"] !== undefined ? _data["mainProductId"] : <any>null;
            this.autoGeneratedDefinition = _data["autoGeneratedDefinition"] !== undefined ? _data["autoGeneratedDefinition"] : <any>null;
            this.isHidden = _data["isHidden"] !== undefined ? _data["isHidden"] : <any>null;
            this.moduleType = _data["moduleType"] !== undefined ? _data["moduleType"] : <any>null;
            this.productType = _data["productType"] !== undefined ? _data["productType"] : <any>null;
            if (Array.isArray(_data["productAttributes"])) {
                this.productAttributes = [] as any;
                for (let item of _data["productAttributes"])
                    this.productAttributes!.push(item);
            }
            else {
                this.productAttributes = <any>null;
            }
            if (Array.isArray(_data["productCategories"])) {
                this.productCategories = [] as any;
                for (let item of _data["productCategories"])
                    this.productCategories!.push(item);
            }
            else {
                this.productCategories = <any>null;
            }
            if (Array.isArray(_data["productImages"])) {
                this.productImages = [] as any;
                for (let item of _data["productImages"])
                    this.productImages!.push(TemplateProductImage.fromJS(item));
            }
            else {
                this.productImages = <any>null;
            }
            if (Array.isArray(_data["productPrices"])) {
                this.productPrices = [] as any;
                for (let item of _data["productPrices"])
                    this.productPrices!.push(TemplateProductPrices.fromJS(item));
            }
            else {
                this.productPrices = <any>null;
            }
        }
    }

    static fromJS(data: any): TemplateProduct {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["fileGuid"] = this.fileGuid !== undefined ? this.fileGuid : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["photographerId"] = this.photographerId !== undefined ? this.photographerId : <any>null;
        data["size"] = this.size !== undefined ? this.size : <any>null;
        data["quantityRangeMin"] = this.quantityRangeMin !== undefined ? this.quantityRangeMin : <any>null;
        data["quantityRangeMax"] = this.quantityRangeMax !== undefined ? this.quantityRangeMax : <any>null;
        data["isAutoGenerated"] = this.isAutoGenerated !== undefined ? this.isAutoGenerated : <any>null;
        data["mainProductId"] = this.mainProductId !== undefined ? this.mainProductId : <any>null;
        data["autoGeneratedDefinition"] = this.autoGeneratedDefinition !== undefined ? this.autoGeneratedDefinition : <any>null;
        data["isHidden"] = this.isHidden !== undefined ? this.isHidden : <any>null;
        data["moduleType"] = this.moduleType !== undefined ? this.moduleType : <any>null;
        data["productType"] = this.productType !== undefined ? this.productType : <any>null;
        if (Array.isArray(this.productAttributes)) {
            data["productAttributes"] = [];
            for (let item of this.productAttributes)
                data["productAttributes"].push(item);
        }
        if (Array.isArray(this.productCategories)) {
            data["productCategories"] = [];
            for (let item of this.productCategories)
                data["productCategories"].push(item);
        }
        if (Array.isArray(this.productImages)) {
            data["productImages"] = [];
            for (let item of this.productImages)
                data["productImages"].push(item.toJSON());
        }
        if (Array.isArray(this.productPrices)) {
            data["productPrices"] = [];
            for (let item of this.productPrices)
                data["productPrices"].push(item.toJSON());
        }
        return data;
    }

    clone(): TemplateProduct {
        const json = this.toJSON();
        let result = new TemplateProduct();
        result.init(json);
        return result;
    }
}

export interface ITemplateProduct {
    id: number;
    name?: string | null;
    description?: string | null;
    price?: number | null;
    fileGuid?: string | null;
    fileName?: string | null;
    photographerId?: number | null;
    size?: number | null;
    quantityRangeMin?: number | null;
    quantityRangeMax?: number | null;
    isAutoGenerated?: boolean | null;
    mainProductId?: number | null;
    autoGeneratedDefinition?: string | null;
    isHidden?: boolean | null;
    moduleType?: number | null;
    productType?: number | null;
    productAttributes: number[];
    productCategories: number[];
    productImages: TemplateProductImage[];
    productPrices: TemplateProductPrices[];
}

export class TemplateProductImage implements ITemplateProductImage {
    id!: number;
    fileGuid?: string | null;
    fileName?: string | null;
    fileUrl?: string | null;
    isDeleted?: boolean | null;
    imageType?: number | null;
    productsTemplates!: TemplateProductTemplate[];

    constructor(data?: ITemplateProductImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.productsTemplates = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.fileGuid = _data["fileGuid"] !== undefined ? _data["fileGuid"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.fileUrl = _data["fileUrl"] !== undefined ? _data["fileUrl"] : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
            this.imageType = _data["imageType"] !== undefined ? _data["imageType"] : <any>null;
            if (Array.isArray(_data["productsTemplates"])) {
                this.productsTemplates = [] as any;
                for (let item of _data["productsTemplates"])
                    this.productsTemplates!.push(TemplateProductTemplate.fromJS(item));
            }
            else {
                this.productsTemplates = <any>null;
            }
        }
    }

    static fromJS(data: any): TemplateProductImage {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateProductImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["fileGuid"] = this.fileGuid !== undefined ? this.fileGuid : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["fileUrl"] = this.fileUrl !== undefined ? this.fileUrl : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        data["imageType"] = this.imageType !== undefined ? this.imageType : <any>null;
        if (Array.isArray(this.productsTemplates)) {
            data["productsTemplates"] = [];
            for (let item of this.productsTemplates)
                data["productsTemplates"].push(item.toJSON());
        }
        return data;
    }

    clone(): TemplateProductImage {
        const json = this.toJSON();
        let result = new TemplateProductImage();
        result.init(json);
        return result;
    }
}

export interface ITemplateProductImage {
    id: number;
    fileGuid?: string | null;
    fileName?: string | null;
    fileUrl?: string | null;
    isDeleted?: boolean | null;
    imageType?: number | null;
    productsTemplates: TemplateProductTemplate[];
}

export class TemplateProductTemplate implements ITemplateProductTemplate {
    id!: number;
    positionX?: number | null;
    positionY?: number | null;
    sizeX?: number | null;
    sizeY?: number | null;
    fileGuid?: string | null;

    constructor(data?: ITemplateProductTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.positionX = _data["positionX"] !== undefined ? _data["positionX"] : <any>null;
            this.positionY = _data["positionY"] !== undefined ? _data["positionY"] : <any>null;
            this.sizeX = _data["sizeX"] !== undefined ? _data["sizeX"] : <any>null;
            this.sizeY = _data["sizeY"] !== undefined ? _data["sizeY"] : <any>null;
            this.fileGuid = _data["fileGuid"] !== undefined ? _data["fileGuid"] : <any>null;
        }
    }

    static fromJS(data: any): TemplateProductTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateProductTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["positionX"] = this.positionX !== undefined ? this.positionX : <any>null;
        data["positionY"] = this.positionY !== undefined ? this.positionY : <any>null;
        data["sizeX"] = this.sizeX !== undefined ? this.sizeX : <any>null;
        data["sizeY"] = this.sizeY !== undefined ? this.sizeY : <any>null;
        data["fileGuid"] = this.fileGuid !== undefined ? this.fileGuid : <any>null;
        return data;
    }

    clone(): TemplateProductTemplate {
        const json = this.toJSON();
        let result = new TemplateProductTemplate();
        result.init(json);
        return result;
    }
}

export interface ITemplateProductTemplate {
    id: number;
    positionX?: number | null;
    positionY?: number | null;
    sizeX?: number | null;
    sizeY?: number | null;
    fileGuid?: string | null;
}

export class TemplateProductPrices implements ITemplateProductPrices {
    id!: number;
    priceLevelFrom?: number | null;
    priceLevelTo?: number | null;
    price?: number | null;

    constructor(data?: ITemplateProductPrices) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.priceLevelFrom = _data["priceLevelFrom"] !== undefined ? _data["priceLevelFrom"] : <any>null;
            this.priceLevelTo = _data["priceLevelTo"] !== undefined ? _data["priceLevelTo"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
        }
    }

    static fromJS(data: any): TemplateProductPrices {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateProductPrices();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["priceLevelFrom"] = this.priceLevelFrom !== undefined ? this.priceLevelFrom : <any>null;
        data["priceLevelTo"] = this.priceLevelTo !== undefined ? this.priceLevelTo : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        return data;
    }

    clone(): TemplateProductPrices {
        const json = this.toJSON();
        let result = new TemplateProductPrices();
        result.init(json);
        return result;
    }
}

export interface ITemplateProductPrices {
    id: number;
    priceLevelFrom?: number | null;
    priceLevelTo?: number | null;
    price?: number | null;
}

export class AuthenticateResponse extends Response implements IAuthenticateResponse {
    token!: string;

    constructor(data?: IAuthenticateResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.token = _data["token"] !== undefined ? _data["token"] : <any>null;
        }
    }

    static fromJS(data: any): AuthenticateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token !== undefined ? this.token : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): AuthenticateResponse {
        const json = this.toJSON();
        let result = new AuthenticateResponse();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateResponse extends IResponse {
    token: string;
}

export class AuthenticateRequest implements IAuthenticateRequest {
    login!: string;
    password!: string;

    constructor(data?: IAuthenticateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.login = _data["login"] !== undefined ? _data["login"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
        }
    }

    static fromJS(data: any): AuthenticateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["login"] = this.login !== undefined ? this.login : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        return data;
    }

    clone(): AuthenticateRequest {
        const json = this.toJSON();
        let result = new AuthenticateRequest();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateRequest {
    login: string;
    password: string;
}

export class EventFileInfoDTO implements IEventFileInfoDTO {
    id!: number;
    fileName!: string;
    createTime!: Date;
    eventName!: string;

    constructor(data?: IEventFileInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.createTime = _data["createTime"] ? new Date(_data["createTime"].toString()) : <any>null;
            this.eventName = _data["eventName"] !== undefined ? _data["eventName"] : <any>null;
        }
    }

    static fromJS(data: any): EventFileInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EventFileInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>null;
        data["eventName"] = this.eventName !== undefined ? this.eventName : <any>null;
        return data;
    }

    clone(): EventFileInfoDTO {
        const json = this.toJSON();
        let result = new EventFileInfoDTO();
        result.init(json);
        return result;
    }
}

export interface IEventFileInfoDTO {
    id: number;
    fileName: string;
    createTime: Date;
    eventName: string;
}

export class ProductDTO implements IProductDTO {
    id!: number;
    name?: string | null;
    description?: string | null;
    price?: number | null;
    createDate?: Date | null;
    modificationDate?: Date | null;
    fileGuid?: string | null;
    fileName?: string | null;
    photographerId?: number | null;
    isDeleted?: boolean | null;
    size?: number | null;
    quantityRangeMin?: number | null;
    quantityRangeMax?: number | null;
    isAutoGenerated?: boolean | null;
    mainProductId?: number | null;
    autoGeneratedDefinition?: string | null;
    isHidden?: boolean | null;
    moduleType?: number | null;
    productType?: number | null;
    imageUrl?: string | null;
    attributes!: AttributeDTO[];
    categories!: CategoryDTO[];
    productPrices!: ProductPriceDTO[];
    productsTemplates!: ProductsTemplateDTO[];

    constructor(data?: IProductDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.attributes = [];
            this.categories = [];
            this.productPrices = [];
            this.productsTemplates = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>null;
            this.modificationDate = _data["modificationDate"] ? new Date(_data["modificationDate"].toString()) : <any>null;
            this.fileGuid = _data["fileGuid"] !== undefined ? _data["fileGuid"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.photographerId = _data["photographerId"] !== undefined ? _data["photographerId"] : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
            this.size = _data["size"] !== undefined ? _data["size"] : <any>null;
            this.quantityRangeMin = _data["quantityRangeMin"] !== undefined ? _data["quantityRangeMin"] : <any>null;
            this.quantityRangeMax = _data["quantityRangeMax"] !== undefined ? _data["quantityRangeMax"] : <any>null;
            this.isAutoGenerated = _data["isAutoGenerated"] !== undefined ? _data["isAutoGenerated"] : <any>null;
            this.mainProductId = _data["mainProductId"] !== undefined ? _data["mainProductId"] : <any>null;
            this.autoGeneratedDefinition = _data["autoGeneratedDefinition"] !== undefined ? _data["autoGeneratedDefinition"] : <any>null;
            this.isHidden = _data["isHidden"] !== undefined ? _data["isHidden"] : <any>null;
            this.moduleType = _data["moduleType"] !== undefined ? _data["moduleType"] : <any>null;
            this.productType = _data["productType"] !== undefined ? _data["productType"] : <any>null;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : <any>null;
            if (Array.isArray(_data["attributes"])) {
                this.attributes = [] as any;
                for (let item of _data["attributes"])
                    this.attributes!.push(AttributeDTO.fromJS(item));
            }
            else {
                this.attributes = <any>null;
            }
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(CategoryDTO.fromJS(item));
            }
            else {
                this.categories = <any>null;
            }
            if (Array.isArray(_data["productPrices"])) {
                this.productPrices = [] as any;
                for (let item of _data["productPrices"])
                    this.productPrices!.push(ProductPriceDTO.fromJS(item));
            }
            else {
                this.productPrices = <any>null;
            }
            if (Array.isArray(_data["productsTemplates"])) {
                this.productsTemplates = [] as any;
                for (let item of _data["productsTemplates"])
                    this.productsTemplates!.push(ProductsTemplateDTO.fromJS(item));
            }
            else {
                this.productsTemplates = <any>null;
            }
        }
    }

    static fromJS(data: any): ProductDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>null;
        data["modificationDate"] = this.modificationDate ? this.modificationDate.toISOString() : <any>null;
        data["fileGuid"] = this.fileGuid !== undefined ? this.fileGuid : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["photographerId"] = this.photographerId !== undefined ? this.photographerId : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        data["size"] = this.size !== undefined ? this.size : <any>null;
        data["quantityRangeMin"] = this.quantityRangeMin !== undefined ? this.quantityRangeMin : <any>null;
        data["quantityRangeMax"] = this.quantityRangeMax !== undefined ? this.quantityRangeMax : <any>null;
        data["isAutoGenerated"] = this.isAutoGenerated !== undefined ? this.isAutoGenerated : <any>null;
        data["mainProductId"] = this.mainProductId !== undefined ? this.mainProductId : <any>null;
        data["autoGeneratedDefinition"] = this.autoGeneratedDefinition !== undefined ? this.autoGeneratedDefinition : <any>null;
        data["isHidden"] = this.isHidden !== undefined ? this.isHidden : <any>null;
        data["moduleType"] = this.moduleType !== undefined ? this.moduleType : <any>null;
        data["productType"] = this.productType !== undefined ? this.productType : <any>null;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : <any>null;
        if (Array.isArray(this.attributes)) {
            data["attributes"] = [];
            for (let item of this.attributes)
                data["attributes"].push(item.toJSON());
        }
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        if (Array.isArray(this.productPrices)) {
            data["productPrices"] = [];
            for (let item of this.productPrices)
                data["productPrices"].push(item.toJSON());
        }
        if (Array.isArray(this.productsTemplates)) {
            data["productsTemplates"] = [];
            for (let item of this.productsTemplates)
                data["productsTemplates"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProductDTO {
        const json = this.toJSON();
        let result = new ProductDTO();
        result.init(json);
        return result;
    }
}

export interface IProductDTO {
    id: number;
    name?: string | null;
    description?: string | null;
    price?: number | null;
    createDate?: Date | null;
    modificationDate?: Date | null;
    fileGuid?: string | null;
    fileName?: string | null;
    photographerId?: number | null;
    isDeleted?: boolean | null;
    size?: number | null;
    quantityRangeMin?: number | null;
    quantityRangeMax?: number | null;
    isAutoGenerated?: boolean | null;
    mainProductId?: number | null;
    autoGeneratedDefinition?: string | null;
    isHidden?: boolean | null;
    moduleType?: number | null;
    productType?: number | null;
    imageUrl?: string | null;
    attributes: AttributeDTO[];
    categories: CategoryDTO[];
    productPrices: ProductPriceDTO[];
    productsTemplates: ProductsTemplateDTO[];
}

export class AttributeDTO implements IAttributeDTO {
    id!: number;
    name!: string;
    isActive?: boolean | null;
    attributesGroupId?: number | null;
    photographerId?: number | null;
    description?: string | null;
    fileGuid?: string | null;
    fileName?: string | null;
    position?: number | null;
    priceCorrectionCurrent?: number | null;
    priceCorrectionPercent?: number | null;
    moduleType?: number | null;
    lastModification?: Date | null;

    constructor(data?: IAttributeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.attributesGroupId = _data["attributesGroupId"] !== undefined ? _data["attributesGroupId"] : <any>null;
            this.photographerId = _data["photographerId"] !== undefined ? _data["photographerId"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.fileGuid = _data["fileGuid"] !== undefined ? _data["fileGuid"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.position = _data["position"] !== undefined ? _data["position"] : <any>null;
            this.priceCorrectionCurrent = _data["priceCorrectionCurrent"] !== undefined ? _data["priceCorrectionCurrent"] : <any>null;
            this.priceCorrectionPercent = _data["priceCorrectionPercent"] !== undefined ? _data["priceCorrectionPercent"] : <any>null;
            this.moduleType = _data["moduleType"] !== undefined ? _data["moduleType"] : <any>null;
            this.lastModification = _data["lastModification"] ? new Date(_data["lastModification"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): AttributeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AttributeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["attributesGroupId"] = this.attributesGroupId !== undefined ? this.attributesGroupId : <any>null;
        data["photographerId"] = this.photographerId !== undefined ? this.photographerId : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["fileGuid"] = this.fileGuid !== undefined ? this.fileGuid : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["position"] = this.position !== undefined ? this.position : <any>null;
        data["priceCorrectionCurrent"] = this.priceCorrectionCurrent !== undefined ? this.priceCorrectionCurrent : <any>null;
        data["priceCorrectionPercent"] = this.priceCorrectionPercent !== undefined ? this.priceCorrectionPercent : <any>null;
        data["moduleType"] = this.moduleType !== undefined ? this.moduleType : <any>null;
        data["lastModification"] = this.lastModification ? this.lastModification.toISOString() : <any>null;
        return data;
    }

    clone(): AttributeDTO {
        const json = this.toJSON();
        let result = new AttributeDTO();
        result.init(json);
        return result;
    }
}

export interface IAttributeDTO {
    id: number;
    name: string;
    isActive?: boolean | null;
    attributesGroupId?: number | null;
    photographerId?: number | null;
    description?: string | null;
    fileGuid?: string | null;
    fileName?: string | null;
    position?: number | null;
    priceCorrectionCurrent?: number | null;
    priceCorrectionPercent?: number | null;
    moduleType?: number | null;
    lastModification?: Date | null;
}

export class CategoryDTO implements ICategoryDTO {
    id!: number;
    name!: string;
    externalKey?: string | null;
    isActive?: boolean | null;
    photographerId?: number | null;
    description?: string | null;
    fileGuid?: string | null;
    fileName?: string | null;
    position?: number | null;
    isHidden?: boolean | null;
    productsPositionDefinition?: string | null;
    moduleType?: number | null;
    lastModification?: Date | null;

    constructor(data?: ICategoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.externalKey = _data["externalKey"] !== undefined ? _data["externalKey"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.photographerId = _data["photographerId"] !== undefined ? _data["photographerId"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.fileGuid = _data["fileGuid"] !== undefined ? _data["fileGuid"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.position = _data["position"] !== undefined ? _data["position"] : <any>null;
            this.isHidden = _data["isHidden"] !== undefined ? _data["isHidden"] : <any>null;
            this.productsPositionDefinition = _data["productsPositionDefinition"] !== undefined ? _data["productsPositionDefinition"] : <any>null;
            this.moduleType = _data["moduleType"] !== undefined ? _data["moduleType"] : <any>null;
            this.lastModification = _data["lastModification"] ? new Date(_data["lastModification"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): CategoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["externalKey"] = this.externalKey !== undefined ? this.externalKey : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["photographerId"] = this.photographerId !== undefined ? this.photographerId : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["fileGuid"] = this.fileGuid !== undefined ? this.fileGuid : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["position"] = this.position !== undefined ? this.position : <any>null;
        data["isHidden"] = this.isHidden !== undefined ? this.isHidden : <any>null;
        data["productsPositionDefinition"] = this.productsPositionDefinition !== undefined ? this.productsPositionDefinition : <any>null;
        data["moduleType"] = this.moduleType !== undefined ? this.moduleType : <any>null;
        data["lastModification"] = this.lastModification ? this.lastModification.toISOString() : <any>null;
        return data;
    }

    clone(): CategoryDTO {
        const json = this.toJSON();
        let result = new CategoryDTO();
        result.init(json);
        return result;
    }
}

export interface ICategoryDTO {
    id: number;
    name: string;
    externalKey?: string | null;
    isActive?: boolean | null;
    photographerId?: number | null;
    description?: string | null;
    fileGuid?: string | null;
    fileName?: string | null;
    position?: number | null;
    isHidden?: boolean | null;
    productsPositionDefinition?: string | null;
    moduleType?: number | null;
    lastModification?: Date | null;
}

export class ProductPriceDTO implements IProductPriceDTO {
    id!: number;
    priceLevelFrom?: number | null;
    priceLevelTo?: number | null;
    price?: number | null;
    isDeleted?: boolean | null;
    productId?: number | null;

    public toString() {
        return JSON.stringify(this);
    }

    constructor(data?: IProductPriceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.priceLevelFrom = _data["priceLevelFrom"] !== undefined ? _data["priceLevelFrom"] : <any>null;
            this.priceLevelTo = _data["priceLevelTo"] !== undefined ? _data["priceLevelTo"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
            this.productId = _data["productId"] !== undefined ? _data["productId"] : <any>null;
        }
    }

    static fromJS(data: any): ProductPriceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductPriceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["priceLevelFrom"] = this.priceLevelFrom !== undefined ? this.priceLevelFrom : <any>null;
        data["priceLevelTo"] = this.priceLevelTo !== undefined ? this.priceLevelTo : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        data["productId"] = this.productId !== undefined ? this.productId : <any>null;
        return data;
    }

    clone(): ProductPriceDTO {
        const json = this.toJSON();
        let result = new ProductPriceDTO();
        result.init(json);
        return result;
    }
}

export interface IProductPriceDTO {
    id: number;
    priceLevelFrom?: number | null;
    priceLevelTo?: number | null;
    price?: number | null;
    isDeleted?: boolean | null;
    productId?: number | null;
}

export class ProductsTemplateDTO implements IProductsTemplateDTO {
    id!: number;
    positionX?: number | null;
    positionY?: number | null;
    sizeX?: number | null;
    sizeY?: number | null;
    fileGuid?: string | null;
    productId!: number;
    page?: number;

    public toString() {
        return JSON.stringify(this);
    }

    constructor(data?: IProductsTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.positionX = _data["positionX"] !== undefined ? _data["positionX"] : <any>null;
            this.positionY = _data["positionY"] !== undefined ? _data["positionY"] : <any>null;
            this.sizeX = _data["sizeX"] !== undefined ? _data["sizeX"] : <any>null;
            this.sizeY = _data["sizeY"] !== undefined ? _data["sizeY"] : <any>null;
            this.fileGuid = _data["fileGuid"] !== undefined ? _data["fileGuid"] : <any>null;
            this.productId = _data["productId"] !== undefined ? _data["productId"] : <any>null;
            this.page = _data["page"] !== undefined ? _data["page"] : <any>null;
        }
    }

    static fromJS(data: any): ProductsTemplateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductsTemplateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["positionX"] = this.positionX !== undefined ? this.positionX : <any>null;
        data["positionY"] = this.positionY !== undefined ? this.positionY : <any>null;
        data["sizeX"] = this.sizeX !== undefined ? this.sizeX : <any>null;
        data["sizeY"] = this.sizeY !== undefined ? this.sizeY : <any>null;
        data["fileGuid"] = this.fileGuid !== undefined ? this.fileGuid : <any>null;
        data["productId"] = this.productId !== undefined ? this.productId : <any>null;
        data["page"] = this.page !== undefined ? this.page : <any>null;
        return data;
    }

    clone(): ProductsTemplateDTO {
        const json = this.toJSON();
        let result = new ProductsTemplateDTO();
        result.init(json);
        return result;
    }
}

export interface IProductsTemplateDTO {
    id: number;
    positionX?: number | null;
    positionY?: number | null;
    sizeX?: number | null;
    sizeY?: number | null;
    fileGuid?: string | null;
    productId: number;
    page?: number;
}

export class Models3D implements IModels3D {
    id!: number;
    name?: string | null;
    description?: string | null;
    fileUrl?: string | null;
    recommendedWidth?: number | null;
    recommendedHeight?: number | null;
    type?: number | null;

    constructor(data?: IModels3D) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.fileUrl = _data["fileUrl"] !== undefined ? _data["fileUrl"] : <any>null;
            this.recommendedWidth = _data["recommendedWidth"] !== undefined ? _data["recommendedWidth"] : <any>null;
            this.recommendedHeight = _data["recommendedHeight"] !== undefined ? _data["recommendedHeight"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
        }
    }

    static fromJS(data: any): Models3D {
        data = typeof data === 'object' ? data : {};
        let result = new Models3D();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["fileUrl"] = this.fileUrl !== undefined ? this.fileUrl : <any>null;
        data["recommendedWidth"] = this.recommendedWidth !== undefined ? this.recommendedWidth : <any>null;
        data["recommendedHeight"] = this.recommendedHeight !== undefined ? this.recommendedHeight : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data;
    }

    clone(): Models3D {
        const json = this.toJSON();
        let result = new Models3D();
        result.init(json);
        return result;
    }
}

export interface IModels3D {
    id: number;
    name?: string | null;
    description?: string | null;
    fileUrl?: string | null;
    recommendedWidth?: number | null;
    recommendedHeight?: number | null;
    type?: number | null;
}



export class Album implements IAlbum {
    id!: number;
    name?: string | null;
    description?: string | null;
    fileUrl?: string | null;
    recommendedWidth?: number | null;
    recommendedHeight?: number | null;
    pageCount?:number | null;
    hasCover?: boolean | null;

    constructor(data?: IAlbum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.fileUrl = _data["fileUrl"] !== undefined ? _data["fileUrl"] : <any>null;
            this.recommendedWidth = _data["recommendedWidth"] !== undefined ? _data["recommendedWidth"] : <any>null;
            this.recommendedHeight = _data["recommendedHeight"] !== undefined ? _data["recommendedHeight"] : <any>null;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : <any>null;
            this.hasCover = _data["hasCover"] !== undefined ? _data["hasCover"] : <any>null;
        }
    }

    static fromJS(data: any): Album {
        data = typeof data === 'object' ? data : {};
        let result = new Album();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["fileUrl"] = this.fileUrl !== undefined ? this.fileUrl : <any>null;
        data["recommendedWidth"] = this.recommendedWidth !== undefined ? this.recommendedWidth : <any>null;
        data["recommendedHeight"] = this.recommendedHeight !== undefined ? this.recommendedHeight : <any>null;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : <any>null;
        data["hasCover"] = this.hasCover !== undefined ? this.hasCover : <any>null;
        return data;
    }

    clone(): Album {
        const json = this.toJSON();
        let result = new Album();
        result.init(json);
        return result;
    }
}

export interface IAlbum {
    id: number;
    name?: string | null;
    description?: string | null;
    fileUrl?: string | null;
    recommendedWidth?: number | null;
    recommendedHeight?: number | null;
    pageCount?: number | null;
    hasCover?: boolean | null;
}

export class Calendar implements ICalendar {
    id!: number;
    name?: string | null;
    description?: string | null;
    fileUrl?: string | null;
    recommendedWidth?: number | null;
    recommendedHeight?: number | null;
    pageCount?:number | null;
    hasCover?: boolean | null;

    constructor(data?: ICalendar) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.fileUrl = _data["fileUrl"] !== undefined ? _data["fileUrl"] : <any>null;
            this.recommendedWidth = _data["recommendedWidth"] !== undefined ? _data["recommendedWidth"] : <any>null;
            this.recommendedHeight = _data["recommendedHeight"] !== undefined ? _data["recommendedHeight"] : <any>null;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : <any>null;
            this.hasCover = _data["hasCover"] !== undefined ? _data["hasCover"] : <any>null;
        }
    }

    static fromJS(data: any): Calendar {
        data = typeof data === 'object' ? data : {};
        let result = new Calendar();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["fileUrl"] = this.fileUrl !== undefined ? this.fileUrl : <any>null;
        data["recommendedWidth"] = this.recommendedWidth !== undefined ? this.recommendedWidth : <any>null;
        data["recommendedHeight"] = this.recommendedHeight !== undefined ? this.recommendedHeight : <any>null;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : <any>null;
        data["hasCover"] = this.hasCover !== undefined ? this.hasCover : <any>null;
        return data;
    }

    clone(): Calendar {
        const json = this.toJSON();
        let result = new Calendar();
        result.init(json);
        return result;
    }
}

export interface ICalendar {
    id: number;
    name?: string | null;
    description?: string | null;
    fileUrl?: string | null;
    recommendedWidth?: number | null;
    recommendedHeight?: number | null;
    pageCount?: number | null;
    hasCover?: boolean | null;
}

export class ShoppingCartItem implements IShoppingCartItem {
    photoId!: number;
    formatCount!: number[];

    constructor(data?: IShoppingCartItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.formatCount = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.photoId = _data["photoId"] !== undefined ? _data["photoId"] : <any>null;
            if (Array.isArray(_data["formatCount"])) {
                this.formatCount = [] as any;
                for (let item of _data["formatCount"])
                    this.formatCount!.push(item);
            }
            else {
                this.formatCount = <any>null;
            }
        }
    }

    static fromJS(data: any): ShoppingCartItem {
        data = typeof data === 'object' ? data : {};
        let result = new ShoppingCartItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["photoId"] = this.photoId !== undefined ? this.photoId : <any>null;
        if (Array.isArray(this.formatCount)) {
            data["formatCount"] = [];
            for (let item of this.formatCount)
                data["formatCount"].push(item);
        }
        return data;
    }

    clone(): ShoppingCartItem {
        const json = this.toJSON();
        let result = new ShoppingCartItem();
        result.init(json);
        return result;
    }
}

export interface IShoppingCartItem {
    photoId: number;
    formatCount: number[];
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}
